module.exports = __webpack_public_path__ + "img/abstract-03012025.99d9a833.jpg";